// Caminho absoluto: src/services/personagemService.ts

import type { PersonagemFase } from '../types/quiz.types';

/**
 * Catálogo slim dos 49 Imortais, bundled pelo Vite (~8 KB).
 * Mesmo padrão de import.meta.glob usado em quizFirebaseService.
 */
const indexModule = import.meta.glob('../../upload/db/personagens_index.json', { eager: true });

export const FASE_TRIBUNAL = 50;

interface PersonagensIndex {
  personagens?: PersonagemFase[];
  fase_tribunal?: { fase: number; titulo: string };
}

function carregarIndex(): PersonagensIndex {
  const key = Object.keys(indexModule)[0];
  if (!key) return {};
  const mod = indexModule[key] as any;
  return (mod?.default ?? mod ?? {}) as PersonagensIndex;
}

const indexData = carregarIndex();
const personagens: PersonagemFase[] = Array.isArray(indexData.personagens) ? indexData.personagens : [];

const porFase = new Map<number, PersonagemFase>();
const porSlug = new Map<string, PersonagemFase>();

for (const p of personagens) {
  if (!porFase.has(p.fase)) porFase.set(p.fase, p);
  if (p.slug) porSlug.set(p.slug, p);
}

export const TITULO_TRIBUNAL = indexData.fase_tribunal?.titulo ?? 'Tribunal dos Antepassados';

/** True quando a fase é o Tribunal (sem Imortal individual). */
export function isFaseTribunal(fase: number): boolean {
  return Number(fase) === FASE_TRIBUNAL;
}

/**
 * Imortal titular da fase. Retorna `null` na Fase 50 — ver `isFaseTribunal`.
 *
 * NOTA DE GAME DESIGN: não existe resolução de retrato por pergunta na Fase 50.
 * Todas as 32 perguntas do Tribunal são anônimas e várias têm o próprio personagem
 * como resposta correta (ex.: "Quem comandou a Revolta da Chibata?"), então exibir o
 * retrato da pergunta ativa entregaria a resposta. Nas fases 1–49 não há esse risco
 * porque o enunciado já nomeia o Imortal.
 */
export function getPersonagemPorFase(fase: number): PersonagemFase | null {
  const n = Number(fase);
  if (isFaseTribunal(n)) return null;
  return porFase.get(n) ?? null;
}

export function getPersonagemPorSlug(slug?: string | null): PersonagemFase | null {
  if (!slug) return null;
  return porSlug.get(slug) ?? null;
}

export function getTodosPersonagens(): PersonagemFase[] {
  return personagens;
}
